"use client";
import { MutableRefObject, ReactNode } from "react";
import Box from "@mui/material/Box";
import { Button, Divider, Icon, Typography } from "@mui/material";
import DOMPurify from "isomorphic-dompurify";
import ArrowLeftIcon from "@/app/_components/Icons/ArrowLeftIcon";
import Arrow2LeftIcon from "@/app/_components/Icons/Arrow2LeftIcon";
import Arrow2RightIcon from "@/app/_components/Icons/Arrow2RightIcon";
import { usePrevNextButtons } from "@/lib/usePrevNextButtons";
import { EmblaCarouselType } from "embla-carousel";
import NextLink from "next/link";

type Props = {
  title: string;
  icon?: ReactNode;
  href?: string;
  emblaApi?: EmblaCarouselType | undefined;
};
export default function CarouselHeader(props: Props) {
  const { icon, title, href, emblaApi } = props;
  const { nextBtnDisabled, onNextButtonClick, onPrevButtonClick, prevBtnDisabled } = usePrevNextButtons(emblaApi);
  return (
    <Box sx={{ display: "flex", flexWrap: "wrap", alignItems: "center", justifyContent: "space-between", gap: 1 }}>
      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 0.2 }}>
        {icon && (
          <Icon fontSize={"large"} sx={{ width: "auto", color: "secondary.main" }}>
            {icon}
          </Icon>
        )}
        <Typography
          variant={"h5"}
          component={"section"}
          sx={{ fontSize: { xs: `0.98rem`, md: "1.4rem" } }}
          fontWeight={400}
          noWrap={true}
          dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(title) }}
        ></Typography>
      </Box>
      <Box sx={{ display: "flex", alignItems: "center", ml: "auto", justifyContent: "space-between", gap: { xs: 0.7, md: 1 } }}>
        {href && (
          <>
            <Button
              component={NextLink}
              href={href}
              aria-label="view-all-button"
              size="small"
              sx={{ borderRadius: 50, minWidth: "auto", px: 0.2, pl: 0.7 }}
              endIcon={
                <Icon sx={{ display: { xs: "none !important", md: "flex  !important" }, fontSize: { xs: "medium", md: "large" } }}>
                  <ArrowLeftIcon />
                </Icon>
              }
            >
              <Typography variant="button" noWrap>
                مشاهده همه
              </Typography>
            </Button>
            <Divider sx={{ display: { xs: "none !important", md: "flex  !important" } }} orientation="vertical" variant="middle" flexItem />
          </>
        )}

        <Button
          sx={{ borderRadius: 50, minWidth: "auto", p: 0.5 }}
          disableElevation={true}
          variant={"contained"}
          color={"primary"}
          disabled={prevBtnDisabled}
          aria-label="prev-button"
          onClick={onPrevButtonClick}
        >
          <Icon sx={{ fontSize: { xs: "medium", md: "large" } }}>
            <Arrow2RightIcon />
          </Icon>
        </Button>
        <Button
          disabled={nextBtnDisabled}
          onClick={onNextButtonClick}
          sx={{ borderRadius: 50, minWidth: "auto", p: 0.5 }}
          disableElevation={true}
          variant={"contained"}
          aria-label="next-button"
          color={"primary"}
        >
          <Icon sx={{ fontSize: { xs: "medium", md: "large" } }}>
            <Arrow2LeftIcon />
          </Icon>
        </Button>
      </Box>
    </Box>
  );
}
